export default __webpack_public_path__ + "static/81492-481598bb5aab767495e48784f0679203.jpg";